const columns = [
  {
    name: 'Status',
    selector: (row) => row.name,
  },
  {
    name: 'Actions',
    selector: (row) => row.actions,
  },
]

export default columns
